export enum CandidateProcessingStatus {
	NotStarted = 1,
	Started = 2,
	Complete = 3,
}
